import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WelcomeComponent } from './welcome/welcome.component';
import { ShopkeeperComponent } from './shopkeeper/shopkeeper.component';
import { CreateshopComponent } from './createshop/createshop.component'
import { LoginComponent } from './login/login.component';
import { CustomerComponent } from './customer/customer.component';
import { ChangepincodeComponent } from './changepincode/changepincode.component';
import { BookinghistoryComponent } from './bookinghistory/bookinghistory.component';
import { SuggestionComponent } from './suggestion/suggestion.component';
import { CustomertokenComponent } from './customertoken/customertoken.component';
import { EntityloginComponent } from './entitylogin/entitylogin.component';
import { ChatcomponentComponent } from './chatcomponent/chatcomponent.component';
import { ChatuserlistComponent } from './chatuserlist/chatuserlist.component';
import { StaffloginComponent } from './stafflogin/stafflogin.component';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'welcome', component: WelcomeComponent },
  { path: 'shopkeeper', component: ShopkeeperComponent },
  { path: 'createshop', component: CreateshopComponent },
  { path: 'login', component: LoginComponent },
  { path: 'customer', component: CustomerComponent },
  { path: 'changepincode', component: ChangepincodeComponent },
  { path: 'bookinghistory', component: BookinghistoryComponent },
  { path: 'suggestion', component: SuggestionComponent },
  { path: 'customertoken/:storeId/:asccode', component: CustomertokenComponent },
  { path: 'entitylogin', component: EntityloginComponent },
  { path: 'chat/:storeId', component: ChatcomponentComponent },
  { path: 'chatusers', component: ChatuserlistComponent },
  { path: 'stafflogin', component: StaffloginComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
